import { onBeforeMount } from "vue";
//@ts-ignore
import { useModalStore } from "@store/ModalStore";
export function useModals() {
  var modalStore = useModalStore();
  function openAndReturnTo(fromModal, toModal, payload) {
    modalStore.openAndReturnTo({
      fromModal: fromModal,
      toModal: toModal,
      payload: payload
    });
  }
  var openModalOnPageReload = function openModalOnPageReload() {
    modalStore.openModalOnPageReload();
  };
  var setShowModal = function setShowModal(modal) {
    modalStore.setShowModal(modal);
  };
  onBeforeMount(function () {
    openModalOnPageReload();
  });
  return {
    setShowModal: setShowModal,
    openAndReturnTo: openAndReturnTo
  };
}